import { Grid, TextField, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import React, { useEffect, useState } from 'react';
import { Controller } from 'react-hook-form';
import { repeatEndItemList } from '.';
import clientUtils from '../../../utils/clientUtils';
import FuelAutoComplete from '../../fuel-autocomplete';

const RepeatEnd = ({ form, onFormChange }) => {
  const [selectedRepeat, setSelectedRepeat] = useState({
    id: 'never',
    name: 'Never',
  });
  const handleRepeatChange = (value) => {
    setSelectedRepeat(value);
    if (value.id === 'count') {
      form.setValue('rrule.count', 10);
      form.setValue('rrule.until', null);
    } else if (value.id === 'until') {
      form.setValue('rrule.until', new Date());
      form.setValue('rrule.count', null);
    } else {
        form.setValue('rrule.count', null);
        form.setValue('rrule.until', null);
    }
    if (onFormChange) {
      onFormChange(form);
    }
  };

  const fieldOnChange = (field, value) => {
    if (field === 'rrule.count' && value && +value > 0) {
      form.setValue(field, +value);
    } else {
      form.setValue(field, value);
    }
    
    if (onFormChange) {
      onFormChange(form);
    }
  };
  useEffect(() => {
    const rrule = form.getValues('rrule');
    if (rrule && rrule.until) {
      form.setValue('rrule.until', rrule.until);
      setSelectedRepeat(repeatEndItemList.find((r) => r.id === 'until'));
    } else if (rrule && rrule.count) {
      form.setValue('rrule.count', rrule.count);
      setSelectedRepeat(repeatEndItemList.find((r) => r.id === 'count'));
    }
  }, [form]);
  return (
    <>
      <Grid item xs={3}>
        <FuelAutoComplete
          id="repeat-select"
          items={repeatEndItemList}
          itemText="name"
          itemKey="id"
          labelText="End"
          placeHolderText=""
          controlWidth={250}
          multiSelect={false}
          labelPaddingTop="-5px"
          onChange={handleRepeatChange}
          defaultValue={selectedRepeat}
        />
      </Grid>
      <Grid item xs={3}>
        {selectedRepeat.name === 'Until' && (
          <Controller
            control={form.control}
            name="until"
            render={({ field: { onChange, name, value } }) => (
              <div className="date-picker-wrapper">
                <DatePicker
                  value={form.getValues('rrule.until')}
                  onChange={(date) => fieldOnChange('rrule.until', date)}
                  label="Date"
                  InputProps={{
                    className: 'date-input',
                  }}
                  renderInput={(params) => (
                    <TextField
                      size="small"
                      InputProps={{
                        className: 'date-input',
                      }}
                      {...params}
                    />
                  )}
                />
              </div>
            )}
          />
        )}
        {selectedRepeat.name === 'Count' && (
          <TextField
            variant="outlined"
            onKeyPress={(event) => clientUtils.keypressAndZeroValueWillNotAllow(event)}
            onPaste={clientUtils.onPaste}
            fullWidth
            size="small"
            value={form.getValues('rrule.count')}
            onChange={(e) => fieldOnChange('rrule.count', e.target.value)}
          />
          
        )}
      </Grid>
    </>
  );
};

export default RepeatEnd;
